export interface LoadScriptProps {
  src: string;
  id?: string;
  async?: boolean;
}

export const loadScript = ({ src, id, async = true }: LoadScriptProps) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    if (id) {
      script.id = id;
    }
    script.async = async;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
};
